<template>
<div class="outage-warning" v-if="showOutageWarning">
      Please save your work as the system will be shutting down for maintenance in
      ~{{countDownValue}} minutes
    </div>
</template>

<script>
import { OutageEvents } from "../outage-events";

export default {
  name: "OutageWarningNotifier",
  async created() {
    OutageEvents.SubscribeForWarning(this.showHideOutageWarning);
  },
  data() {
    return {
      countDownValue: -1,
      showOutageWarning: false,
    };
  },
  computed: {
  },
  methods: {
    showHideOutageWarning(warningInfo) {
      if (warningInfo.show) {
        this.countDownValue = warningInfo.remainingTime;
        this.showOutageWarning = true;
      } else {
        this.showOutageWarning = false;
      }
    },
  },
};
</script>
<style >
.outage-warning {
      width: 100% !important;
    height: 40px;
    background: #dd470d;
    position: absolute;
    z-index: 1001;
    color: white;
    text-align: center;
    padding: 12px;
}

</style>
